import { P2GButton, P2GLink } from '@parcel2go/core-ui';
import { useState } from 'react';

interface props {
  code: string;
  display?: string;
  copied?: string;
  variant?: 'body2' | 'caption' | undefined;
  buttonVariant?: 'primary' | 'secondary' | 'tertiary';
  component?: 'link' | 'button' | undefined;
  onCopy?: () => void;
  fullWidth?: boolean;
}

export default function SelectOrCopy(props: props) {
  const [copying, setCopying] = useState<'IDLE' | 'COPIED' | 'ERROR'>('IDLE');

  const copy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(props.code).then(
        function () {
          setCopying('COPIED');
          if (props.onCopy) {
            props.onCopy();
          }
          setTimeout(() => {
            setCopying('IDLE');
          }, 2000);
        },
        function () {
          setCopying('ERROR');
          setTimeout(() => {
            setCopying('IDLE');
          }, 2000);
        }
      );
    } else {
      setCopying('ERROR');
      setTimeout(() => {
        setCopying('IDLE');
      }, 2000);
    }
  };

  const renderMessage = () => {
    switch (copying) {
      case 'COPIED':
        return props.copied || 'Copied to Clipboard';
      case 'ERROR':
        return 'Failed';
      default:
        return props.display || 'Copy';
    }
  };

  if (props.component === 'button') {
    return (
      <P2GButton style={{ minWidth: 'unset' }} variant={props.buttonVariant} onClick={copy} fullWidth={props.fullWidth}>
        {renderMessage()}
      </P2GButton>
    );
  }

  return (
    <P2GLink variant={props.variant} onClick={copy}>
      {renderMessage()}
    </P2GLink>
  );
}
